import React, { useState, useEffect } from 'react';
import classes from './Dashboard.module.css'
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardHeader from './Components/DashboardHeader/DashboardHeader';
// import Cards from './Components/Cards/Cards';
import Footer from '../../Components/Footer/Footer';
import TricolumnGraph from './Components/TricolumnGraph/TricolumnGraph';
import Graph from './Components/Graph/Graph';
import Graphs from './Components/Graphs/Graph';
import Transact from './Components/Transactions/Transact';
import api, { BASE_URL } from '../../Components/API/Api';
import { useUser } from '../../UserContext';

const Dashboard = () => {
  const [showBusinessInfoModal, setShowBusinessInfoModal] = useState(false);
  const [checkingBusinessInfo, setCheckingBusinessInfo] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();
  
  const pageMap = {
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/accounts': 'Accounting',
    '/reports': 'Reports',
    '/banking': 'Banking',
    '/settings': 'Settings',
  };

  useEffect(() => {
    const checkBusinessInfoCompletion = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const hasPaidPlan = localStorage.getItem('hasPaidPlan') === 'true';

        if (!token) {
          setCheckingBusinessInfo(false);
          return;
        }

        // If user has already paid for a plan, do not block them
        // with the business information modal, even if onboarding
        // or company info is not fully set up yet.
        if (hasPaidPlan) {
          setShowBusinessInfoModal(false);
          document.body.style.overflow = '';
          setCheckingBusinessInfo(false);
          return;
        }

        // Primary check: use user's onboarding status from login data
        if (user && typeof user.onboarding !== 'undefined') {
          const onboardingStatus = String(user.onboarding);

          // Show modal only when onboarding is "0" (business not yet completed)
          if (onboardingStatus === '0') {
            setShowBusinessInfoModal(true);
            document.body.style.overflow = 'hidden';
          }

          // When onboarding is "1", user has completed business registration,
          // so we do NOT show the modal and we don't need further checks.
          setCheckingBusinessInfo(false);
          return;
        }

        // Fallback check: use company info when onboarding flag is not available
        const companyIdHeader = (user && (user.company_id || user?.company?.id)) || localStorage.getItem('company_id') || null;
        const res = await api.get(`/v1/companies/get-info`, {
          headers: {
            company_id: companyIdHeader,
          },
        });
        const item = Array.isArray(res?.data?.data) ? res.data.data[0] : (res?.data?.data || null);
        
        // Business info is considered incomplete if company name is missing or empty
        const isBusinessInfoIncomplete = !item || !item.name || item.name.trim() === '';
        
        if (isBusinessInfoIncomplete) {
          setShowBusinessInfoModal(true);
          document.body.style.overflow = 'hidden';
        }
      } catch (err) {
        // If API call fails (e.g., 404 or no company info) and we don't have onboarding info,
        // keep existing behavior and show the modal so user can complete setup.
        console.error('Failed to fetch company info:', err);
        setShowBusinessInfoModal(true);
        document.body.style.overflow = 'hidden';
      } finally {
        setCheckingBusinessInfo(false);
      }
    };

    checkBusinessInfoCompletion();
  }, [user]);

  const handleRedirectToBusiness = () => {
    document.body.style.overflow = '';
    setShowBusinessInfoModal(false);
    navigate('/business');
  };

  const handleCloseModal = () => {
    // Don't allow closing - user must complete business info
    // Modal will only close when they redirect to business page
  };

  return (
    <div className={classes.body}>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <DashboardHeader />
      {/* <Cards /> */}
      <TricolumnGraph />
      {/* <Graph /> */}
      <Graphs />
      <Transact />
      <Footer />

      {/* Business Information Completion Modal */}
      {showBusinessInfoModal && (
        <div className={classes.modalOverlay} onClick={handleCloseModal}>
          <div className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={classes.modalHeader}>
              <h2 className={classes.modalTitle}>Complete Your Business Information</h2>
            </div>
            <div className={classes.modalBody}>
              <p className={classes.modalMessage}>
                It looks like you haven't completed your business information yet. 
                Please complete your business details to continue using the platform.
              </p>
            </div>
            <div className={classes.modalFooter}>
              <button 
                className={classes.modalButton}
                onClick={handleRedirectToBusiness}
              >
                Complete Business Information
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
